import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, Row, Col, Spin, Alert } from 'antd';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
const apiUrl = process.env.REACT_APP_API_BASE_URL;
const Statistics = () => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchStatistics = async () => {
            try {
                const response = await axios.get(`${apiUrl}/api/statistics`);
                setStats(response.data);
            } catch (err) {
                console.error('İstatistik alma hatası:', err);
                setError(err.response?.data?.message || err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchStatistics();
    }, []);

    if (loading) return <Spin tip="Yükleniyor...">
    <div style={{ minHeight: 100 }}>İçerik yükleniyor...</div>
  </Spin>
  
    if (error) return <Alert message={`Hata: ${error}`} type="error" showIcon />;

    return (
        <div style={{ padding: '20px' }}>
            <h2>İstatistikler</h2>
            <Row gutter={16}>
                <Col span={8}>
                    <Card title="Toplam Abone Sayısı" variant="filled">
                        <h3>{stats?.totalSubscribers ?? 0}</h3>
                    </Card>
                </Col>
                <Col span={8}>
                    <Card title="Toplam Gönderilen E-posta" variant="filled">
                        <h3>{stats?.totalEmailsSent ?? 0}</h3>
                    </Card>
                </Col>
                <Col span={8}>
                    <Card title="Toplam Açılan E-posta" variant="filled">
                        <h3>{stats?.totalEmailsOpened ?? 0}</h3>
                    </Card>
                </Col>
            </Row>

            {/* Grafikler */}
            <Row gutter={16} style={{ marginTop: '20px' }}>
                <Col span={12}>
                    <Card title="Aylık Abone Sayısı">
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={stats?.monthlySubscribers ?? []}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="month" />
                                <YAxis />
                                <Tooltip />
                                <Legend />
                                <Bar dataKey="subscribers" fill="#8884d8" />
                            </BarChart>
                        </ResponsiveContainer>
                    </Card>
                </Col>

                <Col span={12}>
                    <Card title="Aylık Gönderilen E-postalar">
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={stats?.monthlyEmailsSent ?? []}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="month" />
                                <YAxis />
                                <Tooltip />
                                <Legend />
                                <Bar dataKey="emailsSent" fill="#82ca9d" />
                            </BarChart>
                        </ResponsiveContainer>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Statistics;
